export const ONE_DAY_IN_MILISECONDS = 86400 * 1000;
export const ONE_DAY_IN_SECONDS = 86400;
export const ONE_HOUR_IN_SECONDS = 3600;
// Returns a Date, in miliseconds, with truncated time (00h,00m,00s)
export const truncateLocaleDate = (offset = 0) => new Date(Date.now() + offset * 1000).setHours(0, 0, 0, 0);
// https://jira.xing.hh/browse/CODI-97
export const getDaysRemainingFromSeconds = (seconds) => {
    const expectedDayToEnd = truncateLocaleDate(seconds);
    const today = truncateLocaleDate();
    return Math.trunc((expectedDayToEnd - today) / ONE_DAY_IN_MILISECONDS);
};
//# sourceMappingURL=get-days-remaining-from-seconds.js.map